import * as Yup from 'yup';

/**
 * Reusable Yup validation rules
 */

// Email rule
export const emailRule = Yup.string().trim().email('Enter a valid email').required('Email is required');

// Password Rule
export const makePasswordRule = Yup.string()
  .min(8, 'Password must be at least 8 characters')
  .matches(/[A-Z]/, 'Must include at least one uppercase letter')
  .matches(/[a-z]/, 'Must include at least one lowercase letter')
  .matches(/\d/, 'Must include at least one number')
  .matches(/[^A-Za-z0-9]/, 'Must include at least one special character')
  .required('Password is required');

// Confirm Password Rule
export const confirmPasswordRule = Yup.string()
  .oneOf([Yup.ref('password')], 'Passwords must match')
  .required('Confirm your password');

// Generic required string
export const requiredString = (fieldName = 'This field') => Yup.string().required(`${fieldName} is required`);

// Phone number rule
export const phoneNumberRule = Yup.string()
  .matches(/^[0-9]{10}$/, 'Phone number must be exactly 10 digits')
  .required('Phone number is required');
